import {
  fetchMyPromoCampaigns,
  fetchPromoCampaign,
  fetchPromoCampaigns,
} from '../queries/promoCampaigns.queries'

import { skipToken, useQuery } from '@tanstack/react-query'

export const usePromoCampaigns = () =>
  useQuery({
    queryKey: ['promoCampaigns'],
    queryFn: fetchPromoCampaigns,
  })

export const usePromoCampaign = (id?: number) =>
  useQuery({
    queryKey: ['promoCampaign', id],
    queryFn: id
      ? () => {
          if (Number.isNaN(id)) {
            return null
          }
          return fetchPromoCampaign(id)
        }
      : skipToken,
  })

export const useMyPromoCampaigns = () =>
  useQuery({
    queryKey: ['myPromoCampaigns'],
    queryFn: fetchMyPromoCampaigns,
  })
